export enum SelectFilterType {
  Account = "Account",
  Branch = "Branch",
  ItemType = "ItemType",
  Depot = "Depot",
  Customer = "Customer",
  ProgramType = "ProgramType",
  Area = 'Area',
  SubtaskTemplate = 'SubtaskTemplate',
  LabelType = 'LabelType',
  ResourceSkill = 'ResourceSkill'
}
